$(() => {
  function preview($input) {
    const val = $input.val();
    if (val) {
      $('.js-subdomain').text(val);
    } else {
      $('.js-subdomain').text('設定された値');
    }
  }

  $('.js-subdomain-input').on('keyup', e => {
    preview($(e.currentTarget));
  });

  preview($('.js-subdomain-input'));
});
